import type { PriceServiceGroup } from "./PriceTable";
import type { PriceValue } from "./PriceInputCell";

export type CatalogItem = {
  id: string;
  label: string;
  active: boolean;
  compatibleMaterialOptions: { materialOption: { id: string; label: string } }[];
};

export function rowKey(serviceCategoryId: string, materialOptionId: string | null): string {
  return `${serviceCategoryId}:${materialOptionId ?? ""}`;
}

export function mapaDePrecos(linhas: { serviceCategoryId: string; materialOptionId: string | null; priceCents: number }[] | undefined) {
  const map = new Map<string, number>();
  for (const item of linhas ?? []) map.set(rowKey(item.serviceCategoryId, item.materialOptionId), item.priceCents);
  return map;
}

/** Preço de uma chave Serviço×Material com override e percentual — a mesma precedência do motor do
 *  backend (override > base×percentual > sem preço), no cliente pra prévia instantânea. */
export function precoAjustado(base: number | null, override: number | undefined, percent: number): PriceValue {
  if (override != null) return { priceCents: override, badge: "custom", hasOverride: true };
  if (base == null) return { priceCents: null, badge: null, hasOverride: false };
  return { priceCents: Math.round(base * (1 + percent / 100)), badge: percent !== 0 ? "adjusted" : "global", hasOverride: false };
}

export function gruposDoCatalogo(itens: CatalogItem[], resolver: (serviceCategoryId: string, materialOptionId: string | null) => PriceValue): PriceServiceGroup[] {
  return itens.map((service) => ({
    serviceCategoryId: service.id,
    serviceLabel: service.label,
    flat: resolver(service.id, null),
    materials: service.compatibleMaterialOptions.map((cm) => ({
      materialOptionId: cm.materialOption.id,
      materialLabel: cm.materialOption.label,
      ...resolver(service.id, cm.materialOption.id),
    })),
  }));
}

export function soOsDiferenciados(grupos: PriceServiceGroup[]): PriceServiceGroup[] {
  return grupos
    .map((g) => ({ ...g, materials: g.materials.filter((m) => m.hasOverride) }))
    .filter((g) => g.flat.hasOverride || g.materials.length > 0);
}
